import React, { useState } from "react";
import { Copyright } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import TermsOfUseModal from "./TermsOfUseModal";
const WelcomeFooter: React.FC = () => {
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);
  const handleOpenTermsModal = (e: React.MouseEvent) => {
    e.preventDefault();
    setIsTermsModalOpen(true);
  };
  return <>
      <footer className="w-full bg-white border-t py-6 mt-auto">
        <div className="container max-w-screen-xl mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 pb-2">
            
            <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm">
              <span className="text-muted-foreground">
                Need help? Contact <a href="mailto:support@kidsbooked.com" className="underline hover:text-kidsbooked-blue transition-colors">support@kidsbooked.com</a>
              </span>
              <Separator orientation="vertical" className="h-4 hidden md:block" />
              <a href="https://kidsbooked.com/about/" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-kidsbooked-blue transition-colors">
                About KidsBooked
              </a>
              <Separator orientation="vertical" className="h-4 hidden md:block" />
              <a href="https://kidsbooked.com/privacy-policy/" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-kidsbooked-blue transition-colors">
                Privacy policy
              </a>
              <Separator orientation="vertical" className="h-4 hidden md:block" />
              <a href="#" onClick={handleOpenTermsModal} className="text-muted-foreground hover:text-kidsbooked-blue transition-colors">
                Terms of use
              </a>
            </div>
            <div className="text-sm text-muted-foreground">
              <div className="flex items-center gap-1">
                <Copyright size={14} />
                <span>2025 KidsBooked, LLC</span>
              </div>
            </div>
            
          </div>
        </div>
      </footer>

      <TermsOfUseModal isOpen={isTermsModalOpen} onClose={() => setIsTermsModalOpen(false)} />
    </>;
};
export default WelcomeFooter;